import { Route, Routes, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { ViewPrepPage } from "components/pages/ViewPrepPage";
import {
  HomePage,
  AppealPage,
  AddToStudyPlan,
  AlertPage,
  MainPage,
  PracticePage,
  CourseIndex,
  TopicFocus,
  StudyPlanner,
  StudyRecommendationTool,
  StudyPlannerFormPage,
  PracticeModalMobileScreen,
  SelfPacedMainPage,
  SelfPacedHome,
  DrillMobile,
  SelfPacedCourseIndex,
  SelfPacedLiveOnlineSession,
  SelfPacedTest,
  SelfPacedTestModalMobileScreen,
  SelfPacedUnlockMobile,
  DrillSmartMobile,
} from "components/pages";
import { MessageBody } from "components/pages/MessageBodyPage";
import { RescheduleEvent } from "components/pages/RescheduleEvent";
import { decodeToken } from "utils/functions/decodeToken";
import { OnboardingFromsMainPage } from "components/pages/OnboardingFromsMainPage";
import { OnboardingHome } from "components/pages/OnboardingFroms/OnboardingHome";
import {
  ADD_TO_STUDY_PLAN,
  ALERT,
  APPEAL,
  COURSE_INDEX,
  DASHBOARD_PROGRAME,
  DRILL,
  DRILL_SMART,
  GMAT_MATERIAL,
  LAUNCH_PRACTICE_TEST,
  LAUNCH_TEST,
  ONBOARDING_FORMS,
  PRACTICE,
  RESCHEDULE_EVENT,
  SELF_PACED,
  SELF_PACED_PROGRAME,
  STUDY_PLANNER,
  STUDY_PLANNER_FORM,
  STUDY_RECOMMENDATIONS_TOOL,
  TEST,
  TOPIC_FOCUS,
  TOPIC_FOCUS_SESSIONS,
  UNLOCK,
  VIEW_PREP,
} from "utils/constants";
import PrivateRoute from "./PrivateRoute";
import { GMATMaterialMobile } from "components/pages/GMATMaterialMobile";

interface IProps {
  theme: "light" | "dark";
}

export const AppRoutes = ({ theme }: IProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  let payload = decodeToken();

  if (token) {
    payload = jwtDecode(token);
  } else {
    payload = decodeToken();
  }

  return (
    <Routes>
      <Route path={`/${VIEW_PREP}`} element={<ViewPrepPage theme={theme} />} />
      <Route path={`/${TEST}`} element={<MessageBody theme={theme} />} />
      <Route
        element={
          <PrivateRoute token={payload} shouldRenderOnboardingForms={true}>
            <OnboardingFromsMainPage theme={theme} />
          </PrivateRoute>
        }
        path={`/${ONBOARDING_FORMS}`}
      >
        <Route path="" element={<OnboardingHome theme={theme} />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            token={payload}
            allowedProgramType={SELF_PACED_PROGRAME}
          >
            <SelfPacedMainPage theme={theme} />
          </PrivateRoute>
        }
        path={`/${SELF_PACED}`}
      >
        <Route path="" element={<SelfPacedHome theme={theme} />} />
        <Route path={`${TEST}`} element={<SelfPacedTest theme={theme} />} />
        <Route
          path={`${COURSE_INDEX}`}
          element={<SelfPacedCourseIndex theme={theme} />}
        />
        <Route
          path={`${TOPIC_FOCUS_SESSIONS}`}
          element={<SelfPacedLiveOnlineSession theme={theme} />}
        />
        <Route
          path={`${LAUNCH_TEST}`}
          element={<SelfPacedTestModalMobileScreen theme={theme} />}
        />
        <Route
          path={`${UNLOCK}`}
          element={<SelfPacedUnlockMobile theme={theme} />}
        />
        <Route path={`${ALERT}`} element={<AlertPage theme={theme} />} />
        <Route path={`${DRILL}`} element={<DrillMobile theme={theme} />} />
        <Route
          path={`${STUDY_RECOMMENDATIONS_TOOL}`}
          element={<StudyRecommendationTool theme={theme} />}
        />
        <Route
          path={`${DRILL_SMART}`}
          element={<DrillSmartMobile theme={theme} />}
        />
        <Route
          path={`${GMAT_MATERIAL}`}
          element={<GMATMaterialMobile theme={theme} />}
        />
      </Route>
      <Route
        element={
          <PrivateRoute token={payload} allowedProgramType={DASHBOARD_PROGRAME}>
            <MainPage theme={theme} />
          </PrivateRoute>
        }
      >
        <Route path="/" element={<HomePage theme={theme} />} />
        <Route path={`/${APPEAL}`} element={<AppealPage theme={theme} />} />
        <Route
          path={`/${LAUNCH_PRACTICE_TEST}`}
          element={<PracticeModalMobileScreen theme={theme} />}
        />
        <Route path={`/${PRACTICE}`} element={<PracticePage theme={theme} />} />
        <Route
          path={`/${COURSE_INDEX}`}
          element={<CourseIndex theme={theme} />}
        />
        <Route
          path={`/${TOPIC_FOCUS}`}
          element={<TopicFocus theme={theme} />}
        />
        <Route
          path={`/${STUDY_PLANNER}`}
          element={<StudyPlanner theme={theme} />}
        />
        <Route
          path={`/${ADD_TO_STUDY_PLAN}`}
          element={<AddToStudyPlan theme={theme} />}
        />
        <Route path={`/${ALERT}`} element={<AlertPage theme={theme} />} />
        <Route
          path={`/${STUDY_PLANNER_FORM}`}
          element={<StudyPlannerFormPage theme={theme} />}
        />
        <Route
          path={`/${RESCHEDULE_EVENT}`}
          element={<RescheduleEvent theme={theme} />}
        />
        <Route path={`/${DRILL}`} element={<DrillMobile theme={theme} />} />
        <Route
          path={`/${STUDY_RECOMMENDATIONS_TOOL}`}
          element={<StudyRecommendationTool theme={theme} />}
        />
        <Route
          path={`/${GMAT_MATERIAL}`}
          element={<GMATMaterialMobile theme={theme} />}
        />
      </Route>
    </Routes>
  );
};
